import type { Client } from '@src/clients/domain/Client';
import { LoadingPage } from '@src/common/components/LoadingPage';
import type { Order } from '@src/orders/domain/Order';
import { useClient } from '@src/orders/hooks/useClient';
import { useOrder } from '@src/orders/hooks/useOrder';
import { OrderValuesContext } from '@src/orders/OrderValuesContext';
import type { EditOrderFormInputs } from '@src/orders/schemas/EditOrderFormInputs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

export const OrderValuesContextProvider = ({
  orderId,
}: {
  orderId: string;
}) => {
  const { t } = useTranslation();
  const { isLoading: isOrderLoading, order } = useOrder({ id: orderId });
  const { isLoading: isClientLoading, client } = useClient({
    id: order?.clientId ?? '',
  });

  if (isOrderLoading || isClientLoading) {
    return <LoadingPage />;
  }

  if (!order || !client) {
    return <>{t('loadingError')}</>;
  }

  return <OrderValuesProvider order={order} client={client} />;
};
const OrderValuesProvider = ({
  order,
  client,
}: {
  order: Order;
  client: Client;
}) => {
  const orderDefaultValues = order.getMostRecentEntries(
    client,
  ) as EditOrderFormInputs;
  const [values, setValues] = useState<EditOrderFormInputs>(orderDefaultValues);

  return (
    <OrderValuesContext.Provider value={{ values, setValues }}>
      <Outlet />
    </OrderValuesContext.Provider>
  );
};
